/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Core
import { Schema, field } from '@common/validation';

import type { TDomainsFilters } from '@/server/services/Domains';

export const filterPresets: {
    [presetName: string]: TDomainsFilters
} = {
    short: {
        minLength: 0,
        maxLength: 6
    },
    cheap: {
        minPrice: 0,
        maxPrice: 100
    },
    brandable: {
        minBrandability: 80,
        maxBrandability: 100
    },
    positive: {
        minSentiment: 80,
        maxSentiment: 100
    },
    hacks: {
        format: 'hack'
    },
    actionnable: {
        type: 'verb'
    }
}

// TODO: optimize
export const findPreset = (filters: TDomainsFilters) => Object.keys(filterPresets).find((presetName) => 
    (
        Object.keys(filters).filter(k => filters[k] !== undefined).sort().join() 
        === 
        Object.keys( filterPresets[presetName] ).sort().join()
    )
    &&
    Object.entries(filters).every(([key, value]) => filterPresets[presetName][key] === value)
)

export const filtersInfos = {
    brandability: {
        intent: "Filter domains by brandability"
    },
    emotion: {
        intent: "Search domains with positive feeling"
    },
    popularity: {
        intent: "Filter domains by popularity"
    },
    sort: {
        intent: "Sort domains by their attractiveness scores"
    },
    type: {
        intent: "Filter domains by word type"
    },
    demand: {
        intent: "Search the most demanded domains"
    },
}

/*----------------------------------
- SCHEMA
----------------------------------*/
export default new Schema({

    status: field.choice([
        { "label": "Available", "value": "available", color: 'success' },
        { "label": "For sale", "value": "resell", color: 'info' },
        { "label": "Expired", "value": "expired", color: 'gold' },
        { "label": "Expiring soon", "value": "expiring", color: 'warn' },
        //{ "label": "Sold", "value": "sold" }
    ], { opt: true, multiple: true }),

    page: field.int({ opt: true }),

    keywords: field.string({ opt: true, max: 150 }),

    tld: field.string({ opt: true }),

    type: field.choice([
        { "label": "All", "value": undefined },
        { "label": "Noun", "value": "noun" },
        { "label": "Pnound", "value": "pnound" },
        { "label": "Adjective", "value": "adjective" },
        { "label": "Verb", "value": "verb" },
        { "label": "Adjective satellite", "value": "adjective satellite" },
        { "label": "Proverb", "value": "proverb" },
        { "label": "Contraction", "value": "contraction" },
        { "label": "Adverb", "value": "adverb" },
        { "label": "Letter", "value": "letter" },
        { "label": "Interjection", "value": "interjection" },
        { "label": "Pronoun", "value": "pronoun" },
        { "label": "Conjunction", "value": "conjunction" },
        { "label": "PrepPhrase", "value": "prepPhrase" },
        { "label": "Particle", "value": "particle" },
        { "label": "Symbol", "value": "symbol" },
        { "label": "Preposition", "value": "preposition" },
        { "label": "Determiner", "value": "determiner" },
    ], { opt: true }),

    sector: field.string({ opt: true }),

    minDemand: field.int({ opt: true }),
    maxDemand: field.int({ opt: true }),

    minBrandability: field.int({ opt: true }),
    maxBrandability: field.int({ opt: true }),

    minPopularity: field.int({ opt: true }),
    maxPopularity: field.int({ opt: true }),

    minSentiment: field.int({ opt: true }),
    maxSentiment: field.int({ opt: true }),

    minLength: field.int({ opt: true }),
    maxLength: field.int({ opt: true }),

    // domains.purchasePrice removed, prices are checked on the fly
    /*minPrice: field.int({ opt: true }),
    maxPrice: field.int({ opt: true }),*/

    minAttractivity: field.int({ opt: true }),
    maxAttractivity: field.int({ opt: true }),

    format: field.choice([{
        label: 'All',
        value: undefined
    }, {
        label: 'One word',
        value: 'oneWord'
    }, {
        label: 'Domain Hack',
        value: 'hack'
    }], { opt: true }),

    // Don't forget to update the sortable prop in the table columns
    sort: field.choice([{
        label: 'Popularity',
        value: 'wordPopularity'
    }, {
        label: 'Brandability',
        value: 'wordBrandability'
    }, {
        label: 'Positivity',
        value: 'wordSentiment'
    }, {
        label: 'Demand',
        value: 'wordDemand'
    }, {
        label: 'Latest',
        value: 'updated'
    }], { opt: true }),

});